<ng-container rtBlock="sc-blog-pros-cons-block">
    <div rtElem="col">
        <h4 rtElem="head">
            @if (prosCons().prosTitle; as prosTitle) {
                {{ prosTitle }}
            } @else {
                <ng-container i18n="@@blogProsHead">Плюсы</ng-container>
            }
        </h4>
        <ul rtElem="list">
            @for (pro of prosCons().pros; track $index) {
                <li rtElem="item">{{ pro }}</li>
            }
        </ul>
    </div>
    <div rtElem="col">
        <h4 rtElem="head">
            @if (prosCons().consTitle; as consTitle) {
                {{ consTitle }}
            } @else {
                <ng-container i18n="@@blogConsHead">Минусы</ng-container>
            }
        </h4>
        <ul rtElem="list">
            @for (con of prosCons().cons; track $index) {
                <li rtElem="item">{{ con }}</li>
            }
        </ul>
    </div>
</ng-container>
